/**
 * This file is loaded after the Boost PFS JS file.
 */
(function () {
  if (typeof window.chdProductTitleForDisplay !== 'function') {
    window.chdProductTitleForDisplay = function (title) {
      if (title == null || typeof title !== 'string') return title;
      var t = title;
      var subs = ['• Chr. Jørgensen', '•Chr. Jørgensen', ' · Chr. Jørgensen', '· Chr. Jørgensen', ' | Chr. Jørgensen'];
      for (var si = 0; si < subs.length; si++) {
        t = t.split(subs[si]).join('');
      }
      t = t.replace(/\s*[\u2022\u00B7|]\s*Chr\.\s*Jørgensen/gi, '');
      var chdSeriesNames = ['Søllerød', 'Nyholm', 'Nyboder', 'Nørrebro', 'Marielund', 'Ryvang', 'Langelinie', 'Hasseris', 'Holmen', 'Frederiksberg', 'Østerbro', 'Trianglen', 'Kastellet', 'Rungsted', 'Vesterbro', 'København', 'Trørød', 'Værløse', 'Klampenborg', 'Skagen', 'Lyngby'];
      for (var ci = 0; ci < chdSeriesNames.length; ci++) {
        var sn = chdSeriesNames[ci];
        var suff = [' \u2013 ' + sn, ' - ' + sn, '- ' + sn];
        for (var sj = 0; sj < suff.length; sj++) {
          t = t.split(suff[sj]).join('');
        }
      }
      return t.replace(/\s+/g, ' ').trim();
    };
  }
})();

document.addEventListener('DOMContentLoaded', () => {
  // Add your custom JS below here:

  // Collection tabs slider
  collectionTabsMobileSlider(".collection-tabs");
  
});

const collectionTabsMobileSlider = (target = "") => {
  if (!target || typeof window.$ !== 'function' || !window.$.fn || typeof window.$.fn.slick !== 'function') return;
  $(() => {
    const sliders = $(target);
    if (!sliders.length) return;
    const labels = (window.chdBoostSearchLabels || {}).slider;
    if (!labels || !labels.previous || !labels.next) return;
    function arrow(direction, label) {
      return $('<button>', { type: 'button', class: 'slick-' + direction, 'aria-label': label })
        .append($('<img>', { height: 30, width: 30, alt: '', src: '//cdn.shopify.com/s/files/1/1051/6768/files/chevron.png?v=1688631156' }))[0].outerHTML;
    }
    
    function initializeSlider() {
      const options = {
        mobileFirst: true,
        dots: false,
        infinite: false,
        slidesToShow: 1,
        swipeToSlide: true,
        variableWidth: true,
        arrows: true,
        prevArrow: arrow('prev', labels.previous),
        nextArrow: arrow('next', labels.next)
      };
      sliders.not('.slick-initialized').slick(options);
    }

    function destroySlider() {
      sliders.filter('.slick-initialized').slick('unslick');
    }

    function syncSlider() {
        if ($(window).width() <= 1024) {
          initializeSlider();
        } else {
          destroySlider();
        }
    }
    syncSlider();
    $(window).off('resize.chdCollectionTabs').on('resize.chdCollectionTabs', syncSlider);
  });
}
